import React from "react";
import cls from "./FormWrapper.module.scss";

const FormWrapper = (props) => {
  const { children } = props;

  return (
    <div className={cls.TransactionPage}>
      <div>
        <a className={cls.navBack} href={`https://${process.env.REACT_APP_BASE_URL}`}>
          &#10094; К выбору поставщиков
        </a>
      </div>
      <div className={cls.wrapper}>
        {children}
      </div>
    </div>
  );
};

export default FormWrapper;
